/// <reference path="../../svg.d.ts" />
import React from 'react';
import { getIconProps, IconProps } from '../../utils';
import TempSvg from '../../assets/ui/temp.svg?react';

export const TempIcon: React.FC<IconProps> = props => {
  return <TempSvg {...getIconProps(props)} />;
};
